<template>
    <div class="curriculum content">
        <CourseBread />
        <div class="curr_btn">
            <!--<Button v-if="$route.query.courseStatus == 2" type="primary" @click="addPart()">添加part</Button>-->
            <Button type="primary" @click="addPart()">添加part</Button>
            <!-- <Button type="success" @click="showUploadPdf = true"
                >添加PDF</Button
            > -->
            <!-- <el-dialog title="上传PDF" :visible.sync="showUploadPdf">
                123
            </el-dialog> -->
            <!-- <Modal v-model="showUploadPdf" footer-hide title="上传PDF">
                <Upload
                    ref="upload"
                    type="drag"
                    accept=".pdf"
                    :data="uploadPdfData"
                    :action="uploadPdfUrl"
                    :on-success="uploadPdfSuccess"
                >
                    <div style="padding: 30px 0">
                        <Icon
                            v-if="uploading"
                            type="ios-loading"
                            size="18"
                            class="spin-icon-load"
                            style="color: #3399ff; margin-bottom: 10px"
                        ></Icon>
                        <Icon
                            v-else
                            type="md-document"
                            size="40"
                            style="color: #3399ff; margin-bottom: 10px"
                        ></Icon>
                        <p v-if="uploading">PDF文件上传中, 请稍后</p>
                        <p v-else>将PDF文件拖拽到此，或直接上传</p>
                    </div>
                </Upload>
            </Modal> -->
            <!-- <input
                id="uploadForm"
                type="file"
                @change="uploadPdf($event)"
                accept=""
            /> -->
            <!-- <Button type="primary" @click="uploadPdf()">添加pdf</Button> -->
        </div>
        <div class="curr_tab">
            <Table
                :loading="loading"
                border
                ref="selection"
                :columns="columns"
                :data="partList"
            ></Table>
        </div>
    </div>
</template>
<style scoped>
.curr_btn button {
    margin-right: 20px;
}
.curriculum > div {
    padding: 10px 0;
}

.course_div {
    margin-bottom: 10px;
}

.courseName {
    color: #000;
    font-size: 14px;
}

.bgImgSet {
    color: #666;
    font-size: 14px;
}

.course {
    margin-left: 6px;
    color: #ccc;
    font-size: 14px;
}

.courseTi {
    margin-left: 6px;
    font-size: 13px;
    color: #000;
}

.page {
    margin-top: 20px;
}
</style>
<script>
import http from "../../libs/http.js";
import pageComponent from "../common/page.vue";
import { mapGetters } from "vuex";
import { Upload } from "iview";
import util from "@/libs/util.js";
import CourseBread from "./components/CourseBread.vue";
export default {
    data() {
        return {
            loading: false,
            uploading: false,
            showUploadPdf: false,
            courseStatus: this.$route.query.courseStatus,
            courseId: this.$route.query.courseId,
            groupId: this.$route.query.groupId,
            courseTitle: this.$route.query.courseTitle,
            sectionName: this.$route.query.sectionName,
            sectionStatus: this.$route.query.sectionStatus,
            uploadPdfUrl: http.url() + "/madyPart/pdfUpload",
            columns: [
                {
                    title: "No.",
                    type: "index",
                    width: 60,
                },
                {
                    title: "part名称",
                    key: "name",
                },
                {
                    title: "封面图",
                    key: "coverUrl",
                    align: "center",
                    render: (h, params) => {
                        return params.row.coverUrl
                            ? h("img", {
                                  attrs: {
                                      src: params.row.coverUrl,
                                  },
                                  style: {
                                      height: "70px",
                                      marginTop: "5px",
                                  },
                              })
                            : h("span", "暂无图片");
                    },
                },
                {
                    title: "创建时间",
                    key: "createTime",
                    align: "center",
                    render: (h, params) => {
                        const date = new Date(params.row.createTime);
                        const formattedDate = `${date.getFullYear()}-${
                            (date.getMonth() + 1).toString().padStart(2, '0')
                        }-${date.getDate().toString().padStart(2, '0')} ${
                            date.getHours().toString().padStart(2, '0')
                        }:${date.getMinutes().toString().padStart(2, '0')}`;

                        return h("div", formattedDate);
                    }
                },
                {
                    title: "操作",
                    key: "action",
                    width: 400,
                    fixed: "right",
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    height: "70px",
                                    paddingTop: "25px",
                                },
                            },
                            [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                        },
                                        style: {
                                            marginRight: "10px",
                                        },
                                        on: {
                                            click: () => {
                                                this.addPart(params.row);
                                            },
                                        },
                                    },
                                    "编辑part"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                        },
                                        style: {
                                            marginRight: "10px",
                                        },
                                        on: {
                                            click: () => {
                                                this.stepList(params.row);
                                            },
                                        },
                                    },
                                    "step列表"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                            disabled:
                                                this.sectionStatus == 1
                                                    ? this.getLimit == 1 ||
                                                      this.getLimit == 6 ||
                                                      this.getLimit == 11
                                                        ? false
                                                        : true
                                                    : false,
                                        },
                                        style: {
                                            marginRight: "5px",
                                        },
                                        on: {
                                            click: () => {
                                                this.deletePart(params.row.id);
                                            },
                                        },
                                    },
                                    "删除"
                                ),
                                h("ButtonGroup", [
                                    h("Button", {
                                        props: {
                                            type: "info",
                                            size: "small",
                                            icon: "ios-arrow-up",
                                            ghost: true,
                                        },
                                        style: {
                                            marginLeft: "100px",
                                        },
                                        on: {
                                            click: () => {
                                                this.move(params.row, 0);
                                            },
                                        },
                                    }),
                                    h("Button", {
                                        props: {
                                            type: "info",
                                            size: "small",
                                            icon: "ios-arrow-down",
                                            ghost: true,
                                        },
                                        style: {
                                            marginRight: "4px",
                                        },
                                        on: {
                                            click: () => {
                                                this.move(params.row, 1);
                                            },
                                        },
                                    }),
                                ]),
                            ]
                        );
                    },
                },
            ],
            partList: [],
            totalNum: 0,
            pageNum: 1,
            pageSize: 10,
        };
    },
    computed: {
        ...mapGetters(["getLimit"]),
        uploadPdfData() {
            return {
                groupId: this.$route.query.groupId,
            };
        },
    },
    created: function () {
        this.getPart();
    },
    methods: {
        getUrlSearch(path, query) {
            return path + util.setUrlSearch(query);
        },
        uploadPdfSuccess(e) {
            if (e.code === 0) {
                this.showUploadPdf = false;
                this.$Message.success('文件正在后台解析上传，请五分钟后刷新页面查看上传结果');
            }
        },
        back1() {
            this.$router.go(-2);
        },
        back2() {
            this.$router.go(-1);
        },
        //获取sectionList表格
        getPart(page) {
            let that = this;
            that.loading = true;
            http.get("/madyPart/list", {
                groupId: that.groupId,
            }).then((res) => {
                that.loading = false;
                that.partList = res;
            });
        },
        //添加
        addPart(row) {
            const { type, courseStatus, courseId, courseTitle, groupId, sectionName, sectionStatus } = this.$route.query;
            if (row) {
                this.$router.push({
                    path: "addPart",
                    query: {
                        type, courseStatus, courseId, courseTitle, groupId, sectionName, sectionStatus,
                        partId: row.id,
                        page: this.pageNum,
                    },
                });
            } else {
                this.$router.push({
                    path: "addPart",
                    query: {
                        type, courseStatus, courseId, courseTitle, groupId, sectionName, sectionStatus,
                        page: this.pageNum,
                    },
                });
            }
        },
        //跳到step列表
        stepList(row) {
            if (row) {
                const { type, courseStatus, courseId, courseTitle, groupId, sectionName, sectionStatus } = this.$route.query;
                this.$router.push({
                    path: "step",
                    query: {
                        type, courseStatus, courseId, courseTitle, groupId, sectionName, sectionStatus,
                        partId: row.id,
                        partName: row.name,
                        page: this.pageNum,
                    },
                });
            }
        },
        deletePart(id) {
            let that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "确定删除该章节?",
                onOk: () => {
                    http.post("/madyPart/deletes", [id]).then((res) => {
                        if (res) {
                            that.getPart();
                            that.$Message.success("删除成功");
                        }
                    });
                },
            });
        },
        // 移动
        // move(row, type) {
        //     http.post("/custom/section/move", {
        //         seq: row.seq,
        //         id: row.sectionId,
        //         courseId: this.courseId,
        //         up: type,
        //     }).then((res) => {
        //         if (res) {
        //             this.getPart();
        //         }
        //     });
        // },
        // 上,下架
        changeStatus(sectionId, status) {
            let that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "确定" + (status == 1 ? "上架" : "下架") + "该章节?",
                onOk: () => {
                    http.post("/custom/section/edit", {
                        courseId: this.courseId,
                        sectionId: sectionId,
                        status: status,
                    }).then((res) => {
                        if (res) {
                            this.getPart();
                            that.$Message.success(
                                status == 1 ? "上架成功" : "下架成功"
                            );
                        }
                    });
                },
            });
        },
        //上移/下移
        move(row, type) {
            // type 0上移 1下移
            http.post("/madyPart/move", {
                partId: row.id,
                groupId: this.groupId,
                up: type,
            }).then((res) => {
                if (res) {
                    this.getPart();
                }
            });
        },
    },
    components: {
        pageComponent,
        Upload,
        CourseBread,
    },
};
</script>

